"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = void 0;
const styles_1 = require("@mui/material/styles");
const variables_scss_1 = require("../../../../../../scss/variables.scss");
// TODO: move this to a global override if we are to use other components
exports.theme = (0, styles_1.createTheme)({
    typography: {
        fontFamily: "body, sans-serif"
    },
    palette: {
        primary: {
            light: variables_scss_1.colorPrimary,
            main: variables_scss_1.colorPrimary,
            dark: variables_scss_1.colorPrimary
        }
    }
});
//# sourceMappingURL=overrideMuiTheme.js.map